export const settingsPl = {
  settings: {
    common: {
      save: 'Zapisz',
      add: 'Dodaj',
      edit: 'Edytuj',
      cancel: 'Anuluj',
    },
    page: {
      title: 'Ustawienia',
      subtitle: 'Zarządzaj preferencjami i własnymi kategoriami',
      save: 'Zapisz',
      error_prefix: 'Błąd ładowania ustawień',
      sections: {
        preferences: {
          title: 'Preferencje',
          description: 'Zarządzaj ogólnymi preferencjami i ustawieniami',
        },
        theme: {
          label: 'Motyw',
          subtitle: 'Wybierz jasny lub ciemny motyw',
          placeholder: 'Wybierz motyw',
          group_label: 'Motyw',
          options: {
            light: 'Jasny',
            dark: 'Ciemny',
          },
        },
        locale: {
          label: 'Język',
          subtitle: 'Język używany w interfejsie',
          placeholder: 'Wybierz język',
          group_label: 'Język',
          options: {
            en: 'English',
            pl: 'Polski',
          },
        },
        defaultContainersPublic: {
          label: 'Nowe kontenery domyślnie publiczne',
          subtitle: 'Po włączeniu, nowo utworzone kontenery będą domyślnie publiczne',
        },
        profilePublic: {
          label: 'Udostępnij profil publicznie',
          subtitle: 'Pozwól innym zalogowanym użytkownikom przeglądać Twój publiczny profil',
        },
        emailPublic: {
          label: 'Pokaż email w profilu publicznym',
          subtitle: 'Wyświetlaj swój adres email w profilu publicznym (tylko jeśli profil jest publiczny)',
        },
      },
    },
    security: {
      title: 'Bezpieczeństwo',
      description: 'Zarządzaj bezpieczeństwem konta i uwierzytelnianiem dwuskładnikowym',
      setup: 'Włącz 2FA',
      manage: 'Zarządzaj 2FA',
      login_required: 'Zaloguj się, aby zarządzać ustawieniami bezpieczeństwa i uwierzytelnianiem dwuskładnikowym.',
      not_configured: 'Uwierzytelnianie dwuskładnikowe nie jest włączone. Włącz je dla lepszego bezpieczeństwa.',
      totp: {
        title: 'Aplikacja uwierzytelniająca',
        enabled: 'Włączona',
        disabled: 'Nie skonfigurowana',
      },
      passkeys: {
        title: 'Klucze dostępu',
        enabled: 'Włączone',
        disabled: 'Nie skonfigurowane',
        count: '{count} kluczy dostępu | {count} klucz dostępu | {count} klucze dostępu | {count} kluczy dostępu',
      },
      preferred_method: {
        title: 'Preferowana metoda 2FA',
        description: 'Ustaw preferowaną metodę uwierzytelniania dwuskładnikowego',
        label: 'Preferowana metoda',
        placeholder: 'Wybierz preferowaną metodę',
        options: {
          none: 'Automatycznie',
          totp: 'Aplikacja uwierzytelniająca',
          webauthn: 'Klucze dostępu',
        },
        saved: 'Zaktualizowano preferowaną metodę',
        error: 'Nie udało się zaktualizować preferowanej metody',
      },
    },
    preferences: {
      title: 'Preferencje',
      description: 'Zarządzaj preferencjami i ustawieniami aplikacji',
      save: 'Zapisz',
      saved: 'Zapisano',
      imageProcessingMode: {
        label: 'Tryb Przetwarzania Obrazków',
        subtitle: 'Wybierz sposób przetwarzania przesyłanych obrazków (zmiana rozmiaru i kompresja)',
        options: {
          highQuality: 'Wysoka Jakość',
          highQualityDescription: 'Maksymalny rozmiar: 2560x2560px, jakość JPEG: 95%. Najlepsza jakość, większy rozmiar pliku.',
          balanced: 'Zbalansowany',
          balancedDescription: 'Maksymalny rozmiar: 1200x1200px, jakość JPEG: 90%. Dobra równowaga między jakością a rozmiarem pliku.',
          storageSaver: 'Oszczędny',
          storageSaverDescription: 'Maksymalny rozmiar: 800x800px, jakość JPEG: 80%. Mniejszy rozmiar pliku, niższa jakość.',
        },
      },
    },
    categories: {
      title: 'Własne Kategorie',
      description: 'Dodawaj i zarządzaj własnymi kategoriami przedmiotów',
      add: 'Dodaj Kategorię',
      edit: 'Edytuj Kategorię',
      save: 'Zapisz',
      cancel: 'Anuluj',
      deleteConfirm: 'Czy na pewno chcesz usunąć tę kategorię?',
      valuePlaceholder: 'Nazwa kategorii',
      valueRequired: 'Nazwa kategorii jest wymagana',
      empty: 'Brak własnych kategorii. Dodaj pierwszą powyżej.',
    },
    containerTypes: {
      title: 'Własne Typy Kontenerów',
      description: 'Dodawaj i zarządzaj własnymi typami kontenerów',
      add: 'Dodaj Typ Kontenera',
      edit: 'Edytuj Typ Kontenera',
      save: 'Zapisz',
      cancel: 'Anuluj',
      deleteConfirm: 'Czy na pewno chcesz usunąć ten typ kontenera?',
      valuePlaceholder: 'Nazwa typu kontenera',
      valueRequired: 'Nazwa typu kontenera jest wymagana',
      empty: 'Brak własnych typów kontenerów. Dodaj pierwszy powyżej.',
    },
    brands: {
      title: 'Własne Marki',
      description: 'Dodawaj i zarządzaj własnymi markami przedmiotów',
      add: 'Dodaj Markę',
      edit: 'Edytuj Markę',
      save: 'Zapisz',
      cancel: 'Anuluj',
      deleteConfirm: 'Czy na pewno chcesz usunąć tę markę?',
      valuePlaceholder: 'Nazwa marki',
      valueRequired: 'Nazwa marki jest wymagana',
      empty: 'Brak własnych marek. Dodaj pierwszą powyżej.',
    },
    oauth: {
      title: 'Połączenia OAuth',
      description: 'Zarządzaj powiązanymi kontami OAuth (Google, Facebook itp.)',
      login_required: 'Zaloguj się, aby zarządzać połączeniami OAuth.',
      no_connections: 'Brak powiązanych kont OAuth.',
      providers: {
        google: 'Google',
        facebook: 'Facebook',
      },
      connection: {
        linked: 'Połączone',
        deleted: 'Połączenie OAuth zostało usunięte',
        confirm_delete: 'Czy na pewno chcesz usunąć połączenie z {provider}?',
      },
    },
    storage: {
      title: 'Użycie Miejsca',
      description: 'Zobacz użycie i limity miejsca na pliki',
      used: 'Użyto',
      usagePercentage: 'Użycie',
      error: 'Nie można załadować informacji o miejscu',
    },
    integrations: {
      keep: {
        title: 'Google Keep',
        description: 'Lustro listy zakupów jako checklista w Twoim osobistym Google Keep (nieoficjalna, jednokierunkowa synchronizacja).',
        connected: 'Połączono jako {email}',
        lastSync: 'Ostatnia synchronizacja: {time}',
        disconnect: 'Rozłącz',
        confirmDisconnect: 'Rozłączyć Google Keep? Notatki w Keep nie zostaną usunięte, ale synchronizacja się zatrzyma.',
        connectSuccess: 'Połączono z Google Keep',
        connectError: 'Nie udało się połączyć z Google Keep',
        disconnectSuccess: 'Rozłączono z Google Keep',
        disconnectError: 'Nie udało się rozłączyć z Google Keep',
        mirrorCreated: 'Lista zakupów połączona z notatką w Keep',
        mirrorError: 'Operacja na powiązaniu z Keep nie powiodła się',
        syncSuccess: 'Zsynchronizowano z Google Keep',
        syncError: 'Synchronizacja z Google Keep nie powiodła się',
        instructions: {
          step1: 'Włącz weryfikację dwuetapową na koncie Google, potem utwórz hasło aplikacji na myaccount.google.com/apppasswords.',
          step2: 'Uruchom mały skrypt w Pythonie (pip install gpsoauth) z gpsoauth.perform_master_login(email, haslo_aplikacji, device_id) — device_id wybierasz sam (16 znaków hex). Zwraca master token.',
          step3: 'Wklej email, master token i dokładnie ten sam device_id, którego użyłeś w skrypcie — muszą się zgadzać, inaczej Google odrzuci połączenie. Błąd „BadAuthentication"? Zobacz alternatywną metodę w docs/plans/2026-07-07-keep-export.md.',
        },
        form: {
          email: 'Email konta Google',
          masterToken: 'Master token',
          deviceId: 'Device ID (android_id użyty z gpsoauth)',
          deviceIdPlaceholder: 'np. a1b2c3d4e5f60708',
          emailInvalid: 'Podaj poprawny adres email',
          tokenRequired: 'Master token jest wymagany',
          deviceIdRequired: 'Device ID jest wymagany — musi być taki sam jak przy uzyskiwaniu master tokenu',
          understood: 'Rozumiem, że to nieoficjalna integracja i może przestać działać bez ostrzeżenia. Mogę cofnąć dostęp w dowolnym momencie na myaccount.google.com/permissions.',
          revokeHint: 'Możesz cofnąć ten token w dowolnym momencie na myaccount.google.com/permissions.',
          connect: 'Połącz Google Keep',
        },
      },
    },
    delete_account: {
      title: 'Usuń Konto',
      description: 'Trwale usuń swoje konto i wszystkie powiązane dane',
      warning_title: 'Ostrzeżenie: Ta akcja nie może być cofnięta',
      warning_1: 'Wszystkie Twoje dane zostaną trwale usunięte',
      warning_2: 'Utracisz dostęp do wszystkich swoich kontenerów i przedmiotów',
      warning_3: 'Ta akcja nie może być odwrócona',
      button: 'Usuń Konto',
      modal: {
        title: 'Usuń Konto',
        description: 'Czy na pewno chcesz usunąć swoje konto? Ta akcja nie może być cofnięta.',
        warning_title: 'Ostatnie Ostrzeżenie',
        warning_text: 'Po usunięciu konta wszystkie Twoje dane zostaną trwale usunięte i nie będą mogły zostać odzyskane.',
        confirmation_label: 'Wpisz DELETE aby potwierdzić',
        confirmation_hint: 'Proszę wpisać DELETE w polu powyżej, aby potwierdzić usunięcie konta',
        confirm_checkbox: 'Rozumiem, że ta akcja nie może być cofnięta i wszystkie moje dane zostaną trwale usunięte',
        cancel: 'Anuluj',
        delete_button: 'Usuń Konto',
        success: 'Konto zostało pomyślnie usunięte',
        errors: {
          invalid_confirmation: 'Nieprawidłowe potwierdzenie. Proszę wpisać DELETE aby potwierdzić.',
          generic: 'Nie udało się usunąć konta. Proszę spróbować ponownie.',
        },
      },
    },
  },
}

